import { render, staticRenderFns } from "./terminal.vue?vue&type=template&id=6a635a7e&"
import script from "./terminal.vue?vue&type=script&lang=js&"
export * from "./terminal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports